module.exports = __webpack_public_path__ + "img/Azrtxb oard – 2.7266dc82.png";